import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiEndpoint } from '../api';
import { environment } from '../environments/environment';

import { AccessData, CsrfTokenData, SignInWithCodeData } from './auth.abstraction';
import { SessionManagerEndpoint } from './auth.constant';
import { AuthUtility } from './auth.utility';
import { HTTP_ERROR_HANDLED } from './http-context-tokens.constant';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private httpClient = inject(HttpClient);

  getCsrfToken(): Observable<CsrfTokenData> {
    return this.httpClient.get<CsrfTokenData>(`${environment.apiHost}/${ApiEndpoint.Crsf}`);
  }

  logout(): Observable<void> {
    const logoutUrl = AuthUtility.isSessionManagerMode()
      ? `${environment.auth.sessionManagerHost}/${SessionManagerEndpoint.Logout}`
      : `${environment.apiHost}${ApiEndpoint.Logout}`;

    return this.httpClient.post<unknown>(logoutUrl, null, { withCredentials: true })
      .pipe(map(() => void 0));
  }

  refreshToken(refresh: string): Observable<AccessData> {
    return this.httpClient.post<AccessData>(`${environment.apiHost}/auth/refresh/`, { refresh });
  }

  signIn(token: string): Observable<SignInWithCodeData> {
    return this.httpClient.post<SignInWithCodeData>(
      `${environment.apiHost}/auth/signin/`,
      { token },
      { context: new HttpContext().set(HTTP_ERROR_HANDLED, true) },
    );
  }
}
